module.exports = __webpack_public_path__ + "static/media/projects.536d5f5d.svg";